module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med engelsk_sentrert logo_pos(svart).12ced548.pdf";